import { useClipboard } from '@/utils/hooks/useClipboard';
import React from 'react';

export interface CopyButtonProps {
    /** Children callback, provides current status and copy function as an argument */
    children: (payload: { copied: boolean; copy: () => void }) => React.ReactNode;

    /** Value that will be copied to the clipboard when the button is clicked */
    value: string;

    /** Copied status timeout in ms, `1000` by default */
    timeout?: number;
}

const defaultProps: Partial<CopyButtonProps> = {
    timeout: 1000
};

const CopyButton = (props: CopyButtonProps) => {
    const { children, timeout, value, ...others } = { ...defaultProps, ...props };
    const clipboard = useClipboard({ timeout });
    const copy = () => clipboard.copy(value);
    return <>{children({ copy, copied: clipboard.copied, ...others })}</>;
};

export default CopyButton;
